import React from 'react';
import { useDispatch } from 'react-redux';
import { clearUser } from '../../../../userSlice';
import { clearTokens } from '../../../utils/apiUtils';
import './SessionExpiredDialog.scss';

interface SessionExpiredDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const handleReauthorize = () => {
    clearTokens();
    dispatch(clearUser());
    onClose();
    // Принудительно обновляем страницу для синхронизации с useAuth хуком
    window.location.href = '/auth';
  };

  if (!isOpen) return null;

  return (
    <div className="session-expired-overlay" onClick={onClose}>
      <div className="session-expired-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="session-expired-header">
          <h3>Сеанс истек</h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="session-expired-content">
          <p>Ваш сеанс работы истек. Для продолжения работы необходимо повторно авторизоваться.</p>
        </div>

        <div className="session-expired-actions">
          <button
            className="button-primary"
            onClick={handleReauthorize}
          >
            Войти заново
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredDialog;

